export const APP_URL = import.meta.env.VITE_APP_URL ?? (typeof window !== 'undefined' ? window.location.origin : '');
export const FACTORY_ADDRESS = import.meta.env.VITE_FACTORY_ADDRESS ?? '';
export const STON_ROUTER_ADDRESS = import.meta.env.VITE_STON_ROUTER_ADDRESS ?? '';
export const PTON_MASTER_ADDRESS = import.meta.env.VITE_PTON_MASTER_ADDRESS ?? '';
export const NETWORK = (import.meta.env.VITE_NETWORK ?? 'testnet') as 'testnet' | 'mainnet';
export const TON_API = import.meta.env.VITE_TON_API ?? 'https://testnet.toncenter.com/api/v2/jsonRPC';
export const API_URL = import.meta.env.VITE_API_URL ?? '';
export const BOT_USERNAME = import.meta.env.VITE_BOT_USERNAME ?? 'gong';
export const APP_VERSION = import.meta.env.VITE_APP_VERSION ?? 'dev';

export const IS_TESTNET = NETWORK !== 'mainnet';
export const HAS_FACTORY = FACTORY_ADDRESS.length > 0;

/** Default slippage baked into min_out: 100 bps = 1%. */
export const DEFAULT_SLIPPAGE_BPS = 100n;

/** Prepared transaction lifetime. Docs: within a minute, never “price at display time”. */
export const QUOTE_TTL_SECONDS = 45;
